export default __webpack_public_path__ + "static/210528_夏日角色熱更預告_en-dfffb9da9d07d8b6b9580cad10e2413a.webp";